import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { createPortal } from 'react-dom';
import './style.scss';

const Confirmation = ({
  okLabel = 'OK',
  cancelLabel = 'Cancel',
  title = 'Confirmation',
  confirmationMessage = 'Are you sure?',
  enableEscape = false,
  onHide,
  proceed,
}: ConfirmationProps) => {
  return createPortal(
    <div className="static-modal">
      <Modal
        animation={false}
        centered={true}
        show={true}
        backdrop={enableEscape ? true : 'static'}
        keyboard={enableEscape}
        size="sm"
        className="confirm-modal"
      >
        <Modal.Header className="bg-primary justify-content-center">
          <Modal.Title className="fs-6 text-white">{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            className="confirm-modal__message text-center d-flex justify-content-center align-items-center"
            dangerouslySetInnerHTML={{ __html: confirmationMessage }}
          />
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button variant="light" className="me-3" onClick={onHide}>
            {cancelLabel}
          </Button>
          <Button variant="primary" onClick={proceed}>
            {okLabel}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>,
    document.body
  );
};

export default Confirmation;

interface ConfirmationProps {
  okLabel: string;
  cancelLabel: string;
  title: string;
  confirmationMessage: string;
  onHide: () => any;
  enableEscape: boolean;
  proceed: () => any;
}
